import { defineStore } from "pinia";
import { ref } from "vue";
import type { clientType } from "../service/clientType/types";

export const useClientTypesStore = defineStore(
  "clientType",
  () => {
    const clientTypes = ref<clientType[]>([]);

    function setClientTypes(types: clientType[]) {
      clientTypes.value = types;
    }

    function clearClientTypes() {
      clientTypes.value = [];
    }

    function getClientTypes(): clientType[] {
      return clientTypes.value;
    }

    return {
      clientTypes,
      setClientTypes,
      clearClientTypes,
      getClientTypes,
    };
  },
  {
    persist: true,
  }
);
